import { SimpleInput } from '@aloft/toolkit-sui';

export const AdjustPairsLabelInput = ({
  label,
  setLabel,
}: {
  label: string;
  setLabel: (label: string) => void;
}) => (
  <SimpleInput
    value={label}
    variant="grid"
    size="xs"
    onChange={(e) => setLabel(e.currentTarget.value)}
  />
);
